import apiClient from './apiClient';

export const getUserProfile = async () => {
  const response = await apiClient.get('/users/me');

  return response.data.user;
};

export const changeUserPassword = async (currentPassword, newPassword) => {
  const response = await apiClient.put('/users/me/password', {
    currentPassword,
    newPassword,
  });

  return response.data;
};
export const requestEmailChange = async (newEmail, currentPassword) => {
  const response = await apiClient.post('/users/me/email-change', {
    newEmail,
    currentPassword,
  });

  return response.data;
};

const emailChangeConfirmations = new Map();

export const confirmEmailChange = (token) => {
  if (!emailChangeConfirmations.has(token)) {
    const request = apiClient
      .get('/users/confirm-email-change', {
        params: { token },
      })
      .then((response) => response.data);

    emailChangeConfirmations.set(token, request);
  }

  return emailChangeConfirmations.get(token);
};
